import { GoogleMap, Marker, useJsApiLoader } from "@react-google-maps/api";
import React, { useState, useRef, useEffect, useCallback } from "react";
import {
  CardBody,
  CardHeader,
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Form,
  FormGroup,
  Label,
  Input,
  Row,
  Col,
} from "reactstrap";

const AddressCard = ({ addressData, onEdit, onDelete, onSetDefault }) => {
  const [isDefault, setIsDefault] = useState(addressData.isDefault);
  const [map, setMap] = useState(null);
  const [marker, setMarker] = useState(null);
  const [mapError, setMapError] = useState(false);
  const [editModal, setEditModal] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);
  const [autoComplete, setAutoComplete] = useState(null);
  const [mapCenter, setMapCenter] = useState({ lat: 21.478773843809332, lng: 39.18643173979255 })
  const [mapMarker, setMapMarker] = useState({ lat: 21.478773843809332, lng: 39.18643173979255 })
  const [editMapMarker, setEditMapMarker] = useState({ lat: 0.00, lng: 0.00 })
  const [mapLoaded, setMapLoaded] = useState(false);
  const [isEditable, setIsEditable] = useState(false);
  const [editAddress, setEditAddress] = useState("");
  const [address, setAddress] = useState("")
  const searchRef = useRef("");
  const [street, setStreet] = useState("");
  const [editStreet, setEditStreet] = useState("");
  const [editFormData, setEditFormData] = useState({
    title: "",
    address: "",
    isDefault: false,
    phone: "",
    city: "",
    state: "",
    zipCode: "",
    country: "",
  });
  const mapRef = useRef(null);
  // Google map Methods
  const { isLoaded } = useJsApiLoader({
    id: 'google-map-script',
    googleMapsApiKey: process.env.REACT_APP_MAP_API_KEY,
    libraries: ['places']
  });



  const onUnmount = useCallback(function callback(map) {
    setMap(null)
    // setAutoComplete(null)
    setMapLoaded(false)
  }, [])

  const onLoad = (map) => {
    setAutoComplete(new window.google.maps.places.Autocomplete(searchRef.current, { componentRestrictions: { country: "US" } }))
    const bounds = new window.google.maps.LatLngBounds(mapCenter);
    map.fitBounds(bounds);
    setMap(map)
    setMapLoaded(true)
  }

  const onPlaceSelect = () => {
    const place = autoComplete.getPlace()
    if (place.geometry.viewport || place.geometry.location) {
      // console.log('place selected: ', place)
      setStreet(place.formatted_address)
      setEditStreet(place.formatted_address)
      setMapMarker({ lat: place.geometry.location.lat(), lng: place.geometry.location.lng() })
      setEditMapMarker({ lat: place.geometry.location.lat(), lng: place.geometry.location.lng() })
      setMapCenter({ lat: place.geometry.location.lat(), lng: place.geometry.location.lng() })
      map.panTo({ lat: place.geometry.location.lat(), lng: place.geometry.location.lng() })
      map.setZoom(15)
    }
  }

  useEffect(() => {
    if (mapLoaded) {
      autoComplete.addListener('place_changed', onPlaceSelect)
    }
  }, [mapLoaded])


  // Initialize edit form data when addressData changes or modal opens
  useEffect(() => {
  
  }, []);

  // Initialize map
  useEffect(() => {

  }, [addressData.Coordinates]);

  const handleSetDefault = () => {
    setIsDefault(true);
    onSetDefault?.(addressData);
  };


  return (
    <>
      <div className="address-card">
        <CardHeader className="address-card-header">
          <div className={`header-content ${addressData.IsDefault ? "selected-default" : "set-default"}`}>
            <div className="header-actions">
              <h5 className="address-title">{addressData.Title}</h5>
              <div>
                {!addressData.IsDefault && (
                  <Button color="link" className="default-btn" onClick={handleSetDefault}>
                    Set Default
                  </Button>
                )}
                {addressData.IsDefault && <span className="badge badge-success">Default</span>}
              </div>
            </div>
            <div>
              <Button color="link" className="delete-btn" onClick={onDelete}>
                <i className="ri-delete-bin-line"></i>
              </Button>
            </div>
          </div>
        </CardHeader>

        <CardBody>
          {/* Map Section */}
          <div className="map-container">
            <div ref={mapRef} className="map-placeholder" >
              {/* {mapError && (
                <div className="map-fallback">
                  <i className="ri-map-pin-line"></i>
                  <span>Map unavailable</span>
                  <small className="text-muted mt-1">Check Google Maps API configuration</small>
                </div>
              )} */}
              {isLoaded ?
                <GoogleMap clickableIcons={false}
                   center={mapCenter} zoom={12} onLoad={onLoad}
                  options={{ zoomControl: false, streetViewControl: false, mapTypeControl: false, maxZoom: 16 }}
                  mapContainerClassName={"map-container"} onUnmount={onUnmount}>
                  <Marker position=
                    {
                      isEditable
                        ? editMapMarker :
                        mapMarker} />
                </GoogleMap>
                : <></>}
            </div>
          </div>

          {/* Address Details */}
          <div className="address-details">
            <div className="map-controls">
              <span>
                <i className="ri-map-pin-line me-1"></i>
              </span>
              <span className="address-text">{addressData.StreetAddress}</span>
            </div>
            <span className="link edit-button" onClick={onEdit}>
              EDIT
            </span>
          </div>
        </CardBody>
      </div>
    </>
  );
};

export default AddressCard;